module.exports = __webpack_public_path__ + "static/media/img1-4.430d51ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/biosense/diff/img1-4.png
// module id = 2191
// module chunks = 3